"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGraphUtils = exports.createCAGraphUtils = exports.createGraphPrimitiveUtils = exports.distinctSlugContext = exports.remintUiNodeIds = exports.remintDbArtifactIds = exports.splitDisjointGraphs = exports.Clone = void 0;
const caGraphUtils_1 = require("./caGraphUtils");
const primitiveGraphUtils_1 = require("./primitiveGraphUtils");
exports.Clone = __importStar(require("./templateClone"));
// Re-export the pure connected-components helper so callers that only have
// lightweight artifact ids + dependencies (e.g. metadata paths) can reuse the
// same graph logic via the DbGraphUtils namespace.
var dbBasicGraphUtils_1 = require("./dbBasicGraphUtils");
Object.defineProperty(exports, "splitDisjointGraphs", { enumerable: true, get: function () { return dbBasicGraphUtils_1.splitDisjointGraphs; } });
// Shared id re-minting for both graph representations (DB { artifacts,
// dependencies } and UI { nodes, edges }). Consolidates the several call sites
// that hand-rolled an old-id → new-id map + reference rewire.
var remintIds_1 = require("./remintIds");
Object.defineProperty(exports, "remintDbArtifactIds", { enumerable: true, get: function () { return remintIds_1.remintDbArtifactIds; } });
Object.defineProperty(exports, "remintUiNodeIds", { enumerable: true, get: function () { return remintIds_1.remintUiNodeIds; } });
// Derive the distinct { id, slug } CF/LP context from a UI graph's node configs
// (id = slug) for structural validation. Shared by validate_graph + the CLIs.
var slugContext_1 = require("./slugContext");
Object.defineProperty(exports, "distinctSlugContext", { enumerable: true, get: function () { return slugContext_1.distinctSlugContext; } });
__exportStar(require("./serialize"), exports);
__exportStar(require("./meshGrouping"), exports);
var primitiveGraphUtils_2 = require("./primitiveGraphUtils");
Object.defineProperty(exports, "createGraphPrimitiveUtils", { enumerable: true, get: function () { return primitiveGraphUtils_2.createGraphPrimitiveUtils; } });
var caGraphUtils_2 = require("./caGraphUtils");
Object.defineProperty(exports, "createCAGraphUtils", { enumerable: true, get: function () { return caGraphUtils_2.createCAGraphUtils; } });
// ============================================================================
// Public factory: composes the primitive (domain-agnostic) layer with the
// credit-agreement (domain) layer. The returned shape is identical to the
// original createGraphUtils in every member external callers depend on.
// `_internal` is the primitive layer's hand-off to the CA layer only.
// ============================================================================
const createGraphUtils = (params) => {
    const primitive = (0, primitiveGraphUtils_1.createGraphPrimitiveUtils)(params);
    const ca = (0, caGraphUtils_1.createCAGraphUtils)(primitive);
    const { _internal, ...publicPrimitive } = primitive;
    return { ...publicPrimitive, ...ca };
};
exports.createGraphUtils = createGraphUtils;
//# sourceMappingURL=dbGraphUtils.js.map